import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ZoneGeographiqueDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-zone-geographique-select',
  templateUrl: './zone-geographique-select.component.html',
  styleUrls: ['./zone-geographique-select.component.css']
})
export class ZoneGeographiqueSelectComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.zonesGeographiques$) zonesGeographiques$: Observable<ZoneGeographiqueDto[]>;

  @Input('width') width: number;

  @Input() zoneGeographiqueId: number;
  @Output() zoneGeographiqueIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  ZonesGeographiques: ZoneGeographiqueDto[] = [];

  zg: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
    }

  ngOnInit() {
    if(this.zoneGeographiqueId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.zoneGeographiqueId));
    }
    this.zg = this.zonesGeographiques$.subscribe(res => {
      if (res != null) {
        this.ZonesGeographiques = res;
      }
    });
  }

  ngOnDestroy() {
    this.zg?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.zoneGeographiqueId) {
      this.cell.setValue(this.zoneGeographiqueId);
    }
    this.zoneGeographiqueIdChange.emit(this.zoneGeographiqueId);
  }
}
